<template>
  <b-col md="4">
    <b-card class="mb-2">
      <b-tabs>
        <b-tab
          id="tab-right-1"
          title="ดำเนินการ"
        >
          <b-row>

            <b-col
              cols="12"
              class="ml-0"
            >
              <h4>ส่งต่อเจ้าหน้าที่</h4>
            </b-col>
            <b-col cols="12">
              <b-form-group label="ตามการรับผิดชอบบริษัท">
                <b-form-radio-group
                  :options="optionRespCompany"
                  name="radios-stacked"
                  stacked
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="ตามจำนวนความรับผิดชอบงานปัจจุบัน">
                <b-form-radio-group
                  :options="optionRespCount"
                  name="radios-stacked"
                  stacked
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-radio-group
                  :options="optionRespCustom"
                  name="radios-stacked"
                  stacked
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-select
                :options="optionOfficers"
                class=""
              />
            </b-col>

            <b-col cols="12 mt-2">
              <b-form-group
                label="ความเห็นเจ้าหน้าที่"
                label-for="offficerComment"
              >
                <b-form-textarea
                  id="offficerComment"
                  placeholder="ความเห็นเจ้าหน้าที่"
                  rows="6"
                />
              </b-form-group>

              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-col>

            <b-col
              cols="12"
              class="d-flex justify-content-between mt-2"
            >
              <b-button variant="secondary">
                ยกเลิก
              </b-button>
              <b-button variant="primary">
                ดำเนินการ
              </b-button>
            </b-col>

          </b-row>
        </b-tab>
        <b-tab
          id="tab-right-2"
          title="ประวัติ"
        />
      </b-tabs>
    </b-card>
  </b-col>

</template>

<script>

import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard, BFormRadioGroup, BFormSelect, BFormFile, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
  },
  data() {
    return {
      optionRespCompany: [
        { text: 'เจ้าหน้าที่ ฮงบันจัง', value: 1 },
      ],
      optionRespCount: [
        { text: 'เจ้าหน้าที่ ฮเยจัน (6)', value: 2 },
        { text: 'เจ้าหน้าที่ จีซองฉยอน (8)', value: 3 },
        { text: 'เจ้าหน้าที่ โฮจูรี (12)', value: 4 },
      ],
      optionRespCustom: [
        { text: 'กำหนดเอง', value: 999 },
      ],
      optionOfficers: [
        { text: 'เจ้าหน้าที่ ฮเยจัน', value: 2 },
        { text: 'เจ้าหน้าที่ จีซองฉยอน', value: 3 },
        { text: 'เจ้าหน้าที่ โฮจูรี', value: 4 },
      ],
    }
  },
}
</script>

<style>

</style>
